const deutsch = {
  'TABLES.Column_Title_Name' : 'Name',
  'TABLES.Column_Title_Phone' : 'Telefon',
  'TABLES.Column_Title_Email' : 'E-Mail',
  'TABLES.Column_Title_Company' : 'Unternehmen',
  'TABLES.Column_Title_Supplier' : 'Lieferant',
  'TABLES.Column_Title_User' : 'User',
  'TABLES.Column_Title_Time' : 'Zeit',
  'TABLES.Column_Title_JobType' : 'Jobtyp',
  'TABLES.Column_Title_Roles' : 'Userrechte',
  'TABLES.Column_Title_Teams' : 'Teams',
  'TABLES.Column_Title_Type' : 'Typ',
  'TABLES.Column_Title_Label' : 'Label',
  'TABLES.Column_Title_Title' : 'Bezeichnung',
  'TABLES.Column_Title_Status' : 'Status',
  'TABLES.Column_Title_Description' : 'Beschreibung',
  'TABLES.Column_Title_ID' : 'ID',
  'TABLES.Column_Sorting_Tooltip_Ascending' : 'Aufsteigend sortieren',
  'TABLES.Column_Sorting_Tooltip_Descending' : 'Absteigend sortieren',
  'TABLES.Column_Sorting_Tooltip_Cancel' : 'Sortierung löschen',
  'TABLES.Column_Title_FileName' : 'Dateiname',
  'TABLES.Column_Title_RoleName' : 'Rechtename',
  'TABLES.Column_Title_NumberRights' : 'Anzahl Userrechte',
  'TABLES.Column_Title_NumberRightsLibrary' : 'Anzahl Userrechte (Library)',
  'TABLES.Column_Title_NumberRightsApp' : 'Anzahl Userrechte (App)',
  'TABLES.Column_Title_NumberUsers' : 'Anzahl User',
  'TABLES.Column_Title_SupplierName' : 'Lieferant',
  'TABLES.Column_Title_Number' : 'Kreditor',
  'TABLES.Column_Title_UsersNumber' : 'Nutzeranzahl',
  'TABLES.Column_Title_KeyAmount' : 'Anzahl Regeln',
  'TABLES.Column_Title_GroupName' : 'Gruppenname',
  'TABLES.Column_Title_Key' : 'Regel',
  'TABLES.Column_Title_Editable' : 'Editierbar',
  'TABLES.Column_Title_Records' : 'Statistik (Einträge)',
  'TABLES.Column_Title_Found' : 'Gefunden',
  'TABLES.Column_Title_New' : 'Neu',
  'TABLES.Column_Title_Updated' : 'Aktualisiert',
  'TABLES.Column_Title_TeamName' : 'Teamname',
  'TABLES.Column_Title_Head' : 'Verantwortlicher',
  'TABLES.Column_Title_NumbProjectManager' : 'Anzahl Projektmanager',
  'TABLES.Column_Title_NumbDraftsMen' : 'Anzahl CAD-Zeichner',
  'TABLES.Column_Title_Image' : 'Bild',
  'TABLES.Column_Title_Article' : 'Artikelnr.',
  'TABLES.Column_Title_Color' : 'Farbe',
  'TABLES.Column_Title_NavisionNumb' : 'NAV-Nr.',
  'TABLES.Column_Title_OctacadNumb' : 'CAD-Nr.',
  'TABLES.Column_Title_SupplierNumb' : 'Lieferantenartikelnr.',
  'TABLES.Column_Title_ContentLang' : 'Sprache',
  'TABLES.Column_Title_Organizer' : 'Veranstalter',
  'TABLES.Column_Title_Price' : 'Preis',
  'TABLES.Column_Title_SizeMinMax' : 'Größe (qm)',
  'TABLES.Column_Title_PricePer' : 'Preis pro qm (€)',
  'TABLES.Column_Title_Orientations' : 'Standtyp',
  'TABLES.Column_Title_RuleType' : 'Regeltyp',
  'TABLES.Column_Title_StandSizeSqm' : 'Standgröße (qm)',
  'TABLES.Column_Title_Amount' : 'Anzahl',
  'TABLES.Column_Title_NumberStands' : 'Anzahl Stände',
  'TABLES.Column_Title_NumberEquipment' : 'Anzahl Ausstattungselemente',
  'TABLES.Column_Title_NumberFlooring' : 'Anzahl Bodenbeläge',
  'TABLES.Column_Title_Logo' : 'Logo',
  'TABLES.Column_Title_PrintingCompany' : 'Grafikfirma',
  'TABLES.Column_Title_Leistungscode' : 'Leistungsbeschreibung',
  'TABLES.Column_Title_EPFertigungListe' : 'Einzelpreis Fertigungsliste',
  'TABLES.Column_Title_EPMontageWerkstatt' : 'Einzelpreis Montage in Werkstatt',
  'TABLES.Column_Title_EPMontageStand' : 'Einzelpreis Montage am Stand',
  'TABLES.Column_Title_Lettering': 'Blendenbeschriftung',
  'TABLES.Column_Title_3dModel' : '3D-Modell',
  'TABLES.Column_Title_Slug' : 'Slug',
  'TABLES.Column_Title_Action' : 'Aktion',
  'TABLES.Column_Title_EntryPoint': 'Einstiegspunkt',
  'TABLES.Column_Title_ExhibitionTypes': 'Veranstaltungstypen',
  'FORM_RULES.Min_NewPassword' : 'Passwort muss mindestens { minLength } Zeichen enthalten.',
  'FORM_RULES.Required_NewPassword' : 'Neues Passwort eingeben',
  'FORM_RULES.Required_ConfirmPassword' : 'Neues Passwort bestätigen',
  'FORM_RULES.Required_ConfirmPasswordMatch' : 'Die eingegebenen Passwörter stimmen nicht überein.',
  'FORM_RULES.Required_Name' : 'Vornamen eingeben',
  'FORM_RULES.Required_ArticleEquipment' : 'Artikelbezeichnung eingeben',
  'FORM_RULES.Required_Surname' : 'Nachnamen eingeben',
  'FORM_RULES.Required_Email' : 'Die eingegebene E-Mail ist ungültig.',
  'FORM_RULES.Required_Choose': 'auswählen',
  'FORM_RULES.Required_ChooseType': 'Typ auswählen',
  'FORM_RULES.Required_ChooseColor': 'Material/Farbgruppe auswählen',
  'FORM_RULES.Required_Phone' : 'Telefonnummer eingeben',
  'FORM_RULES.Required_Title' : 'Beschreibung eingeben',
  'FORM_RULES.Required_Number' : 'Kreditorennr. eingeben',
  'FORM_RULES.Required_Where' : 'Bitte wählen Sie aus, wo Sie die Zeit ändern möchten',
  'FORM_RULES.Required_Password' : 'Passwort eingeben',
  'FORM_RULES.Required_RoleName' : 'Rechtename eingeben',
  'FORM_RULES.Required_Color' : 'Farbe eingeben',
  'FORM_RULES.Required_SupplierName' : 'Lieferanten eingeben',
  'FORM_RULES.Required_Key' : 'Key eingeben',
  'FORM_RULES.Required_Article' : 'Artikelnummer eingeben',
  'FORM_RULES.Required_SupplierArticle' : 'Lieferantenartikelnr. eingeben',
  'FORM_RULES.Required_OctacadNumb' : 'CAD-Nr. eingeben',
  'FORM_RULES.Required_NavisionArticle' : 'Navisionnr. eingeben',
  'FORM_RULES.Required_Price' : 'Preis eingeben',
  'FORM_RULES.Required_StandName' : 'Standnamen eingeben',
  'FORM_RULES.Required_MinSizeSqm' : 'Mindestgröße eingeben',
  'FORM_RULES.Required_MaxSizeSqm' : 'Maximalgröße eingeben',
  'FORM_RULES.Required_PricePerSqm' : 'Preis eingeben',
  'FORM_RULES.Required_SizeMinMax' : 'Größe eingeben',
  'FORM_RULES.Required_Amount' : 'Anzahl eingeben',
  'FORM_RULES.Required_RuleType' : 'Regeltyp eingeben',
  'FORM_RULES.Required_TeamName' : 'Teamnamen eingeben',
  'FORM_RULES.Required_TeamType' : 'Teamtyp auswählen',
  'FORM_RULES.Required_OrganizerName' : 'Veranstalternamen eingeben',
  'FORM_RULES.Required_ExhibitionName': 'Veranstaltungstypnamen eingeben',
  'FORM_RULES.Required_ExhibitionTypes': 'Veranstaltungstypen auswählen',
  'FORM_RULES.Required_Leistungscode' : 'Leistungsbeschreibung eingeben',
  'FORM_RULES.Required_EPFertigungListe' : 'EP Fertigungsliste eingeben',
  'FORM_RULES.Required_EPMontageWerkstatt' : 'EP Montage in Werkstatt eingeben',
  'FORM_RULES.Required_EPMontageStand' : 'EP Montage am Stand eingeben',
  'FORM_RULES.Required_FreeCharactersAmount' : 'Anzahl der Inklusivzeichen eingeben',
  'FORM_RULES.Required_AdditionalPrice' : 'Preis pro Zusatzbuchstabe eingeben',
  'FORM_RULES.Invalid_Phone': 'Die eingegebene Telefonnummer ist ungültig.',
  'FORM_RULES.Required_Organizer': 'Veranstalter eingeben',
  'FORM_RULES.Required_PrintingCompany': 'Grafikfirma eingeben',
  'FORM_RULES.Required_MaxCharacter': 'Max. Zeichen eingeben',
  'FORMS.Input_Label_Password' : 'Passwort',
  'FORMS.Input_Label_Login' : 'Login',
  'FORMS.Input_Label_NewPassword' : 'Neues Passwort',
  'FORMS.Input_Label_ConfirmPassword' : 'Neues Passwort bestätigen',
  'FORMS.Input_Label_Language' : 'Sprache',
  'FORMS.Input_Label_Name' : 'Vorname',
  'FORMS.Input_Label_Surname' : 'Nachname',
  'FORMS.Input_Label_Phone' : 'Telefon',
  'FORMS.Input_Label_Email' : 'E-Mail',
  'FORMS.Input_Label_Title' : 'Dateiname',
  'FORMS.Input_Label_Number' : 'Nr.',
  'FORMS.Input_Label_Description' : 'Beschreibung',
  'FORMS.Input_Label_Status': 'Status',
  'FORMS.Input_Label_Lettering': 'Blendenbeschriftung',
  'FORMS.Input_Label_IntrfaceLanguage' : 'Menüsprache auswählen',
  'FORMS.Input_Label_ContentLanguage' : 'Contentsprache auswählen',
  'FORMS.Input_Label_RoleName' : 'Rechtename',
  'FORMS.Input_Label_Color' : 'Farbe',
  'FORMS.Input_Label_BaseColor' : 'Material/Farbgruppe',
  'FORMS.Input_Label_Role' : 'Rechte',
  'FORMS.Input_Label_SupplierName' : 'Lieferantenname',
  'FORMS.Input_Label_GroupName' : 'Gruppenname',
  'FORMS.Input_Label_Key' : 'Key',
  'FORMS.Input_Label_EditableKey' : 'Key editierbar',
  'FORMS.Input_Label_Supplier' : 'Lieferant',
  'FORMS.Input_Label_Head' : 'Verantwortlicher',
  'FORMS.Input_Label_TeamName' : 'Teamname',
  'FORMS.Input_Label_Team' : 'Team',
  'FORMS.Input_Label_ProjectManagers' : 'Projektmanager',
  'FORMS.Input_Label_ConstructionManagers' : 'Bauleiter',
  'FORMS.Input_Label_AutocadEngineers' : 'CAD-Zeichner',
  'FORMS.Input_Label_AssignedTeams' : 'Zugewiesene Teams',
  'FORMS.Input_Label_Type' : 'Typ',
  'FORMS.Input_Label_Article' : 'Bezeichnung',
  'FORMS.Input_Label_Images' : 'Bilder',
  'FORMS.Input_Label_SupplierArticle' : 'Lieferantenartikelnr.',
  'FORMS.Input_Label_OctacadArticle' : 'CAD-Nr.',
  'FORMS.Input_Label_NavisionNumb' : 'Navisionnr.',
  'FORMS.Input_Label_Price' : 'Preis',
  'FORMS.Input_Label_StandName' : 'Standvariante',
  'FORMS.Input_Label_MinSizeSqm' : 'Mindestgröße (qm)',
  'FORMS.Input_Label_MaxSizeSqm' : 'Maximalgröße (qm)',
  'FORMS.Input_Label_PricePerSqm' : 'Preis pro qm (€)',
  'FORMS.Input_Label_Complexity' : 'Standkomplexität',
  'FORMS.Input_Label_MinPrice' : 'Mindestpreis (€)',
  'FORMS.Input_Label_MaxPrice' : 'Maximalpreis (€)',
  'FORMS.Input_Label_Orientations' : 'Standtyp',
  'FORMS.Input_Label_SignIn' : 'Anmelden',
  'FORMS.Input_Label_StandSizeMinSqm' : 'Mindeststandgröße (qm)',
  'FORMS.Input_Label_StandSizeMaxSqm' : 'Maximalstandgröße (qm)',
  'FORMS.Input_Label_Amount' : 'Anzahl',
  'FORMS.Input_Label_StandRuleType' : 'Regeltyp',
  'FORMS.Input_Label_EquipmentName' : 'Artikelbezeichnung',
  'FORMS.Input_Label_Equipment' : 'Ausstattung',
  'FORMS.Input_Label_AddText' : 'Text hinzufügen',
  'FORMS.Input_Label_OrganizerName' : 'Veranstaltername',
  'FORMS.Input_Label_Organizer' : 'Veranstalter',
  'FORMS.Input_Label_EquipmentSuppliers' : 'Lieferant Ausstattung',
  'FORMS.Input_Label_PrintHouseSuppliers' : 'Lieferant Grafik',
  'FORMS.Input_Label_FlooringSuppliers' : 'Bodenbelaglieferant',
  'FORMS.Input_Label_Logo' : 'Logo',
  'FORMS.Input_Label_ExhibitionName' : 'Veranstaltungstypname',
  'FORMS.Input_Label_ExhibitionTypes' : 'Veranstaltungstypen',
  'FORMS.Input_Label_Organizers' : 'Veranstalter',
  'FORMS.Input_Label_Materials' : 'Druckmaterialien',
  'FORMS.Input_Label_ColorsOracal' : 'Farben (Oracal)',
  'FORMS.Input_Label_AssemblyTypes' : 'Montagetypen',
  'FORMS.Input_Label_PrintingCompany' : 'Grafikfirma',
  'FORMS.Input_Label_Leistungscode' : 'Leistungscode',
  'FORMS.Input_Label_EPFertigungListe' : 'EP Fertigung Liste',
  'FORMS.Input_Label_EPMontageWerkstatt' : 'EP Montage Werkstatt',
  'FORMS.Input_Label_EPMontageStand' : 'EP Montage Stand',
  'FORMS.Input_Label_FreeCharactersAmount' : 'Anzahl kostenlose Zeichen',
  'FORMS.Input_Label_AdditionalPrice': 'Zusatzpreis',
  'FORMS.Input_Label_NameArticle' : 'Artikelname',
  'FORMS.Input_Label_NameOfArticle': 'Artikelname',
  'FORMS.Input_Label_Model3d': '3D-Modell',
  'FORMS.Input_Label_3DModelUrl': '3D-Modell URL',
  'FORMS.Input_Label_Slug' : 'Slug',
  'FORMS.Input_Label_Action' : 'Aktion',
  'FORMS.Input_Label_EntryPoint': 'Einstiegspunkt',
  'FORMS.Input_Label_JobType': 'Jobtyp',
  'FORMS.Title_ChangePassword' : 'Passwort ändern',
  'FORMS.Title_SendPassword' : 'Passwort senden',
  'FORMS.Title_AddUsers' : 'User hinzufügen',
  'FORMS.Title_ChooseType' : 'Typ wählen',
  'FORMS.Title_Text_Filters' : 'Filter',
  'FORMS.Title_Text_AddEquipmentRule' : 'Neue Ausstattungsregel hinzufügen',
  'FORMS.Title_Text_EditEquipmentRule' : 'Ausstattungsregel ändern',
  'FORMS.Title_Text_AddFlooringStand' : 'Neuen Bodenbelag zur Standvariante hinzufügen',
  'FORMS.Title_Text_AddFlooringExhibition' : 'Neuen Bodenbelag zum Veranstaltungstyp hinzufügen',
  'FORMS.Title_Text_AddStandExhibition' : 'Neue Standvariante zum Veranstaltungstyp hinzufügen',
  'FORMS.Title_Text_AddFlooringOrganizer' : 'Neuen Bodenbelag zum Veranstalter hinzufügen',
  'FORMS.Title_Text_AddStandOrganizer' : 'Neuen Standtyp zum Veranstalter hinzufügen',
  'FORMS.Title_Text_EditFile' : 'Datei bearbeiten',
  'FORMS.Title_AddNote' : 'Notiz hinzufügen',
  'FORMS.Title_Text_EditNote' : 'Notiz bearbeiten',
  'FORMS.Title_EditFile' : 'Datei bearbeiten',
  'FORMS.Title_AddRoles' : 'Rechterollen hinzufügen',
  'FORMS.Title_CreateNewKey' : 'Neuen Key anlegen',
  'FORMS.Title_EditKey' : 'Key bearbeiten',
  'FORMS.Title_AddSupplier' : 'Lieferant hinzufügen',
  'FORMS.Title_SelectSupplier' : 'Lieferant auswählen',
  'FORMS.Title_SelectPrintingCompany' : 'Grafikfirma auswählen',
  'FORMS.Title_AddHead' : 'Verantwortlichen hinzufügen',
  'FORMS.Title_AddProjectManagers' : 'Projektmanager hinzufügen',
  'FORMS.Title_AddConstructionManagers' : 'Bauleiter hinzufügen',
  'FORMS.Title_AddAutocadEngineers' : 'CAD-Zeichner hinzufügen',
  'FORMS.Title_AddTeams' : 'Team hinzufügen',
  'FORMS.Title_AddOrientations' : 'Standtyp hinzufügen',
  'FORMS.Title_CreateVariation' : 'Artikelvariante anlegen',
  'FORMS.Title_EditVariation' : 'Artikelvariante bearbeiten',
  'FORMS.Title_AddSubstitude' : 'Ersatzartikel hinzufügen',
  'FORMS.Title_ChooseEquipment' : 'Ausstattung auswählen',
  'FORMS.Title_UploadFile' : 'Datei hochladen',
  'FORMS.Title_AddEquipmentSuppliers' : 'Ausstattungslieferant hinzufügen',
  'FORMS.Title_AddPrintHouseSuppliers' : 'Grafiklieferant hinzufügen',
  'FORMS.Title_AddFlooringSuppliers' : 'Bodenbelaglieferant hinzufügen',
  'FORMS.Title_AddOrganizer': 'Veranstalter hinzufügen',
  'FORMS.Title_SelectOrganizer' : 'Veranstalter wählen',
  'FORMS.Title_Text_AddEquipmentOrganizer' : 'Neue Ausstattungsartikel hinzufügen',
  'FORMS.Title_Text_AddEquipmentExhibition' : 'Neue Ausstattungsartikel zum Veranstaltungstyp hinzufügen',
  'FORMS.Title_AddExhibitionTypes' : 'Veranstaltungstyp hinzufügen',
  'FORMS.Title_AddOrganizers' : 'Veranstalter hinzufügen',
  'FORMS.Title_AddGraphicMaterials' : 'Druckmaterial hinzufügen',
  'FORMS.Title_AddGraphicColorsOracal' : 'Grafikfarben (Oracal) hinzufügen',
  'FORMS.Title_AddAssemblyTypes' : 'Montageort hinzufügen',
  'FORMS.Title_EditGraphicRule' : 'Grafikpreise bearbeiten',
  'FORMS.Title_AddPrintingCompany' : 'Grafikfirma hinzufügen',
  'FORMS.Title_CreateGraphicRule' : 'Grafikregel anlegen',
  'FORMS.Title_Add3DModel': '3D-Modell hinzufügen',
  'FORM_RULES.Required_3DModelUrl': 'Bitte geben Sie die 3D-Modell-URL ein',
  'FORM_RULES.Invalid_Url': 'Bitte geben Sie eine gültige URL (http/https) ein',
  'FORMS.Select_OptionLabel_NotAssigned' : 'Nicht zugewiesen',
  'FORMS.Select_OptionLabel_TypeNotSet' : 'Nicht zugewiesen',
  'FORMS.Select_OptionLabel_English' : 'Englisch',
  'FORMS.Select_OptionLabel_Deutsch' : 'Deutsch',
  'FORMS.Select_OptionLabel_Full' : 'Komplett',
  'FORMS.Select_OptionLabel_CAD' : 'CAD',
  'FORMS.Select_OptionLabel_ChooseColor' : 'Farbe wählen',
  'FORMS.Select_OptionLabel_Active' : 'Aktiv',
  'FORMS.Select_OptionLabel_Blocked' : 'Gesperrt',
  'FORMS.Input_Placeholder_Email' : 'E-Mail',
  'FORMS.Input_Placeholder_Password' : 'Passwort',
  'FORMS.Input_Placeholder_Choose' : 'Auswählen',
  'FORMS.Input_Placeholder_ChooseColor' : 'Farbe wählen',
  'FORMS.Input_Placeholder_Name' : 'Name',
  'FORMS.Input_Placeholder_PleaseChose' : 'Auswählen',
  'FORMS.Input_Placeholder_NotAssigned' : 'Nicht zugewiesen',
  'FORMS.Headig_Text_AppRights' : 'App Userrechte',
  'FORMS.Headig_Text_LibraryRights' : 'Bibliothek - Rollenrechte',
  'FORMS.Headig_Text_Special' : 'Sonderrechte',
  'FORMS.Headig_Text_User' : 'User',
  'FORMS.Headig_Text_Exhibitions' : 'Veranstaltungen',
  'FORMS.Headig_Text_Description' : 'Beschreibung',
  'FORMS.Headig_Text_Organizers' : 'Veranstalter',
  'FORMS.Button_Text_ApplyFilters' : 'Filter setzen',
  'FORMS.Button_Text_ResetFilters' : 'Filter löschen',
  'FORMS.Button_Text_Filters' : 'Filter',
  'FORMS.Button_Text_Reset' : 'Filter löschen',
  'SEARCH.Input_Placeholder_Table_User' : 'Name, E-Mail, Telefon suchen',
  'SEARCH.Input_Placeholder_MultiSelect' : 'Suche',
  'GLOBAL.Button_Text_Save' : 'Speichern',
  'GLOBAL.Button_Text_Send' : 'Senden',
  'GLOBAL.Button_Text_SaveSend' : 'Speichern und senden',
  'GLOBAL.Button_Text_SaveChanges' : 'Änderungen speichern',
  'GLOBAL.Button_Text_CreateNew' : 'Neu',
  'GLOBAL.Button_Text_Create' : 'Anlegen',
  'GLOBAL.Button_Text_Cancel' : 'Abbrechen',
  'GLOBAL.Button_Text_Delete' : 'Löschen',
  'GLOBAL.Button_Text_Remove' : 'Löschen',
  'GLOBAL.Button_Text_Confirm' : 'Bestätigen',
  'GLOBAL.Button_Text_Upload' : 'Hochladen',
  'GLOBAL.Button_Text_Login' : 'Login',
  'GLOBAL.Button_Text_BackHome' : 'Zum Start',
  'GLOBAL.Modal_Text_UserSendPass' : 'Neues Passwort wirklich versenden?',
  'GLOBAL.Modal_Text_RemoveText' : '{ deleteObjectType } wirklich enfernen?',
  'GLOBAL.Modal_Text_DeleteText' : '{ deleteObjectType } wirklich löschen?',
  'GLOBAL.Modal_Text_ResetFilters' : 'Filter löschen',
  'GLOBAL.Button_Text_AddNew' : 'Neu anlegen',
  'GLOBAL.Button_Text_AddKey' : 'Key hinzufügen',
  'GLOBAL.Button_Text_Creat' : 'Anlegen',
  'GLOBAL.Button_Text_DeleteGroup' : 'Gruppe löschen',
  'GLOBAL.Button_Text_DeleteItem' : 'Artikel löschen',
  'GLOBAL.Button_Text_DeleteStand' : 'Standvariante löschen',
  'GLOBAL.Button_Text_AddTranslation' : 'Übersetzung hinzufügen',
  'GLOBAL.Button_Text_AddMore' : 'Hinzufügen',
  'GLOBAL.Button_Text_AddFile' : 'Datei hinzufügen',
  'GLOBAL.Button_Text_AddDescription' : 'Beschreibung hinzufügen',
  'GLOBAL.Button_Text_AddRule' : 'Hinzufügen',
  'GLOBAL.Button_Text_EditRule' : 'Ändern',
  'GLOBAL.Button_Text_Add' : 'Hinzufügen',
  'GLOBAL.Button_Text_Edit' : 'Bearbeiten',
  'GLOBAL.Button_Text_DeleteFile' : 'Datei löschen',
  'GLOBAL.Button_Text_UploadNew' : 'Hochladen',
  'GLOBAL.Button_Text_AddNote' : 'Notiz hinzufügen',
  'GLOBAL.Button_Text_DeleteNote' : 'Notiz löschen',
  'GLOBAL.Button_Text_DeleteOrganizer' : 'Veranstalter löschen',
  'GLOBAL.Button_Text_AddOrganizer' : 'Veranstalter hinzufügen',
  'GLOBAL.Text_NoData' : 'Keine Daten vorhanden',
  'GLOBAL.Text_Status_Disabled' : 'Deaktiviert',
  'GLOBAL.Text_Status_InProgress' : 'In Bearbeitung',
  'GLOBAL.Text_Status_Completed' : 'Fertiggestellt',
  'GLOBAL.Text_AddImage' : 'Bild hinzufügen',
  'GLOBAL.Text_AddLogo': 'Logo hinzufügen',
  'GLOBAL.Text_Active' : 'Aktiv',
  'GLOBAL.Text_Blocked' : 'Gesperrt',
  'GLOBAL.Text_Sqm': 'qm',
  'GLOBAL.Text_AllRights': 'Alle Rechte',
  'GLOBAL.Button_Text_Add3DModel': '3D-Modell Link',
  'GLOBAL.Text_3DModelUnavailable': '3D-Modell nicht verfügbar',
  'GLOBAL.Text_LinkUploaded': 'Link geladen',
  'MODAL.Button_Text_AddRole' : 'Rechterolle hinzufügen',
  'MODAL.Button_Text_AddMore' : 'Hinzufügen',
  'MODAL.Button_Text_AddTeam' : 'Team hinzufügen',
  'MODAL.Button_Text_AddSupplier' : 'Lieferant hinzufügen',
  'MODAL.Button_Text_AddOrientation' : 'Standtyp wählen',
  'MODAL.Button_Text_AddExhibitionType': 'Veranstaltungstyp hinzufügen',
  'MODAL.Button_Text_LogoSize' : 'mind. 220 x 65',
  'MODAL.Button_Text_ImgSize' : 'mind. 800 x 800',
  'MODAL.Title_Text_SuppliersFileImporting' : 'Die Lieferantendatei wird importiert...',
  'MODAL.Title_Text_SuppliersFileImported' : 'Die Lieferantendatei wurde importiert:',
  'ENTITY.Modal_Title_User' : 'User',
  'ENTITY.Modal_Title_Role' : 'Rechterolle',
  'ENTITY.Modal_Title_Supplier' : 'Lieferant',
  'ENTITY.Modal_Title_Key' : 'Key',
  'ENTITY.Modal_Title_Group' : 'Gruppe',
  'ENTITY.Modal_Title_Flooring' : 'Bodenbelag',
  'ENTITY.Modal_Title_Equipment' : 'Ausstattung',
  'ENTITY.Modal_Title_Variation' : 'Artikelvariante',
  'ENTITY.Modal_Title_Stand' : 'Stand',
  'ENTITY.Modal_Title_StandEquipment' : 'Grundausstattung',
  'ENTITY.Modal_Title_File' : 'Datei',
  'ENTITY.Modal_Title_Note' : 'Notiz',
  'ENTITY.Modal_Title_Team' : 'Team',
  'ENTITY.Modal_Title_Organizer' : 'Veranstalter',
  'ENTITY.Modal_Title_ExhibitionType' : 'Veranstaltungstyp',
  'ENTITY.Modal_Title_StandType' : 'Standtyp',
  'ENTITY.Modal_Title_Graphic' : 'Grafik',
  'ENTITY.Modal_Title_GraphicRule': 'Grafikregel',
  'ENTITY.Modal_Title_Permission': 'Berechtigung',
  'MENUS_DROP.Label_Users' : 'User',
  'MENUS_DROP.Label_Logout' : 'Logout',
  'MENUS_DROP.Label_Edit' : 'Ändern',
  'MENUS_DROP.Label_SendPass' : 'Passwort senden',
  'MENUS_DROP.Label_Delete' : 'Löschen',
  'MENUS_DROP.Label_Organizers' : 'Veranstalter',
  'MENUS_DROP.Label_Suppliers' : 'Lieferanten',
  'MENUS_DROP.Label_Teams' : 'Teams',
  'MENUS_DROP.Label_StandTypes' : 'Standvarianten',
  'MENUS_DROP.Label_Equipment' : 'Ausstattung',
  'MENUS_DROP.Label_Flooring' : 'Bodenbelag',
  'MENUS_DROP.Label_Settings' : 'Grundeinstellungen',
  'MENUS_DROP.Label_MyProfile' : 'Mein Profil',
  'MENUS_DROP.Label_UploadIcon' : 'Icon hochladen',
  'MENUS_DROP.Label_MakeDefault' : 'Als Standard festlegen',
  'MENUS_DROP.Label_Permissions' : 'Berechtigungen',
  'NAVBAR_PAGES.Label_Overview' : 'Details',
  'NAVBAR_PAGES.Label_Users' : 'User',
  'NAVBAR_PAGES.Label_UserRoles' : 'Userrollen',
  'NAVBAR_PAGES.Label_VariableLists' : 'Variablenliste',
  'NAVBAR_PAGES.Label_Variations' : 'Varianten',
  'NAVBAR_PAGES.Label_Substitude' : 'Ersatzartikel',
  'NAVBAR_PAGES.Label_Equipments' : 'Ausstattung',
  'NAVBAR_PAGES.Label_Equipment' : 'Ausstattung',
  'NAVBAR_PAGES.Label_Floorings' : 'Bodenbelag',
  'NAVBAR_PAGES.Label_Flooring' : 'Bodenbelag',
  'NAVBAR_PAGES.Label_Files' : 'Dateien',
  'NAVBAR_PAGES.Label_Notes' : 'Notizen',
  'NAVBAR_PAGES.Label_Organizers' : 'Veranstalter',
  'NAVBAR_PAGES.Label_ExhibitionTypes' : 'Veranstaltungstypen',
  'NAVBAR_PAGES.Label_StandTypes' : 'Standvarianten',
  'NAVBAR_PAGES.Label_GraphicRules' : 'Grafikregeln',
  'NAVBAR_PAGES.Label_Rules': 'Regeln',
  'NAVBAR_PAGES.Label_Permissions': 'Berechtigungen (Entwickler)',
  'BREADCRUMBS.Label_Users' : 'User',
  'BREADCRUMBS.Label_Roles' : 'Userrollen',
  'BREADCRUMBS.Label_Create' : 'Anlegen',
  'BREADCRUMBS.Label_Suppliers' : 'Lieferanten',
  'BREADCRUMBS.Label_VariableLists' : 'Variablenliste',
  'BREADCRUMBS.Label_Teams' : 'Teams',
  'BREADCRUMBS.Label_Flooring' : 'Bodenbelag',
  'BREADCRUMBS.Label_Equipment' : 'Ausstattung',
  'BREADCRUMBS.Label_Variations' : 'Artikelvarianten',
  'BREADCRUMBS.Label_Substitude' : 'Ersatzartikel',
  'BREADCRUMBS.Label_StandTypes' : 'Standtypen',
  'BREADCRUMBS.Label_Equipments' : 'Ausstattung',
  'BREADCRUMBS.Label_Floorings' : 'Bodenbelag',
  'BREADCRUMBS.Label_Files' : 'Dateien',
  'BREADCRUMBS.Label_Notes' : 'Notizen',
  'BREADCRUMBS.Label_Organizers' : 'Veranstalter',
  'BREADCRUMBS.Label_Exhibitions' : 'Veranstaltungstypen',
  'BREADCRUMBS.Label_ExhibitionCreate' : 'Veranstaltungstypen anlegen',
  'BREADCRUMBS.Label_GraphicRules' : 'Grafikregeln',
  'BREADCRUMBS.Label_Rules' : 'Regeln',
  'BREADCRUMBS.Label_Permissions' : 'Berechtigungen',
  'PAGES.Title_CreateGroup' : 'Gruppe anlegen',
  'PAGES.Title_Dashboard' : 'Dashboard',
  'PAGES.Title_Users' : 'User',
  'PAGES.Title_CreateUser' : 'User anlegen',
  'PAGES.Title_CreateRole' : 'Userrolle anlegen',
  'PAGES.Title_CreateSupplier' : 'Lieferant anlegen',
  'PAGES.Title_CreateFlooring' : 'Bodenbelag anlegen',
  'PAGES.Title_CreateEquipment' : 'Ausstattungsartikel anlegen',
  'PAGES.Title_CreateTeam' : 'Team anlegen',
  'PAGES.Title_Suppliers' : 'Lieferanten',
  'PAGES.Title_Settings' : 'Einstellungen',
  'PAGES.Title_Teams' : 'Teams',
  'PAGES.Title_Flooring' : 'Bodenbelag',
  'PAGES.Title_Equipment' : 'Ausstattung',
  'PAGES.Title_StandTypes' : 'Standvarianten',
  'PAGES.Title_CreateStand' : 'Standvariante anlegen',
  'PAGES.Title_Organizers' : 'Veranstalter',
  'PAGES.Title_CreateOrganizer' : 'Veranstalter anlegen',
  'PAGES.Title_Exhibitions' : 'Veranstaltungstypen',
  'PAGES.Title_CreateExhibition' : 'Veranstaltungstyp anlegen',
  'PAGES.Title_CreateGraphicRules' : 'Grafikregel anlegen',
  'PAGES.Title_Permissions' : 'Berechtigungen',
  'PAGES.Title_CreatePermission' : 'Berechtigung anlegen',
  'PAGES.Text_404' : 'Entschuldigung, die gesuchte Seite existiert nicht.',
  'PAGES.Text_403' : 'Entschuldigung, Sie haben keine Berechtigung, auf diese Seite zuzugreifen.',
  'CARD.Info_List_BaseColor' : 'Farbgruppe',
  'CARD.Info_List_Type' : 'Materialgruppe',
  'CARD.Info_List_Supplier' : 'Lieferant',
  'CARD.Info_List_OctacadNumb' : 'CAD-Nr.',
  'CARD.Info_List_SupplierNumb' : 'Lieferantenartikelnr.',
  'CARD.Info_List_NavisionNumb' : 'NAV-Nr.',
  'CARD.Info_List_Size' : 'Größe',
  'CARD.Info_List_PricePer' : 'Preis pro qm',
  'CARD.Info_List_Default' : 'Standard',
  'STANDTYPE.Equipment_Rule_EQ' : 'Gleich',
  'STANDTYPE.Equipment_Rule_GTE' : 'Größer/gleich',
  'STANDTYPE.Equipment_Rule_LTE' : 'Kleiner/gleich ',
  'STANDTYPE.Equipment_Rule_BETWEEN' : 'von ... bis',
  'VARIABLE.Label_EMPTY' : '! Keine Übersetzung vorhanden !',
  'USER.Button_Text_Delete' : 'User löschen',
  'ROLE.Button_Text_Delete' : 'Userrechterolle löschen',
  'SUPPLIER.Button_Text_Delete' : 'Lieferant löschen',
  'SUPPLIER.Button_Text_Import' : 'Lieferanten importieren',
  'TEAM.Button_Text_Delete' : 'Team löschen',
  'ORGANIZER.Button_Text_Delete' : 'Veranstalter löschen',
  'EXHIBITION.Button_Text_Delete' : 'Veranstaltungstyp löschen',
  'GRAPHIC.Button_Text_Delete' : 'Grafikregel löschen',
  'PERMISSION.Button_Text_Delete' : 'Berechtigung löschen',
  'PERMISSION.Error_AccessDenied' : 'Zugriff verweigert',
  'PERMISSION.Error_FailedToLoad' : 'Fehler beim Laden der Benutzerberechtigungen',
  'PERMISSION.Error_NoPermission' : 'Sie haben keine Berechtigung für diese Aktion',
  'PERMISSION.Error_NoAccessToSystem' : 'Sie haben keinen Zugang zum System. Bitte kontaktieren Sie Ihren Administrator.',
  'PERMISSION.Error_NoAccessToAnyPage' : 'Sie haben keinen Zugang zu keiner Seite im System. Bitte kontaktieren Sie Ihren Administrator.',
  'TABLES.Column_Title_Sender' : 'Absender',
  'TABLES.Column_Title_StandNumber' : 'Standnummer',
  'TABLES.Column_Title_Changes' : 'Änderungen',
  'TABLES.Column_Title_Received' : 'Eingegangen',
  'TABLES.Column_Title_Confidence' : 'Sicherheit',
  'TABLES.Column_Title_ApprovedBy' : 'Freigegeben von',
  'TABLES.Column_Title_ApprovedAt' : 'Freigegeben am',
  'FORM_RULES.Required_EventName' : 'Messenamen eingeben',
  'FORM_RULES.Required_CompanyName' : 'Firmenname eingeben',
  'FORM_RULES.Required_StandNumber' : 'Standnummer eingeben',
  'FORM_RULES.Required_Item' : 'Artikelbezeichnung eingeben',
  'FORMS.Input_Label_Sender' : 'Absender',
  'FORMS.Input_Label_ReceivedAt' : 'Eingegangen am',
  'FORMS.Input_Label_Subject' : 'Betreff',
  'FORMS.Input_Label_Confidence' : 'Sicherheit',
  'FORMS.Input_Label_EventName' : 'Messe',
  'FORMS.Input_Label_CompanyName' : 'Firmenname',
  'FORMS.Input_Label_StandNumber' : 'Standnummer',
  'FORMS.Input_Label_AISummary' : 'KI-Zusammenfassung',
  'FORMS.Input_Label_AIReason' : 'KI-Begründung',
  'FORMS.Input_Label_OriginalEmail' : 'Original E-Mail',
  'FORMS.Input_Label_Item' : 'Artikel',
  'FORMS.Input_Label_Flooring' : 'Bodenbelag',
  'FORMS.Input_Label_CarpetColor' : 'Teppichfarbe',
  'FORMS.Input_Label_ManagerNote' : 'Manager-Notiz',
  'FORMS.Input_Label_ReceivedDate' : 'Eingangsdatum',
  'GLOBAL.Button_Text_Approve' : 'Freigeben',
  'GLOBAL.Button_Text_ResetData' : 'Daten zurücksetzen',
  'MENUS_DROP.Label_CommunicationBoard' : 'Communication Board',
  'NAVBAR_PAGES.Label_CommunicationInbox' : 'Posteingang',
  'NAVBAR_PAGES.Label_CommunicationPending' : 'Zur Freigabe',
  'NAVBAR_PAGES.Label_CommunicationUnidentified' : 'Zuordnung nötig',
  'NAVBAR_PAGES.Label_CommunicationAudit' : 'Verlauf',
  'BREADCRUMBS.Label_CommunicationBoard' : 'Communication Board',
  'PAGES.Title_CommunicationBoard' : 'Communication Board',
  'permission_group_communication_board' : 'Communication Board',
  'permission_view_communication_board' : 'Communication Board anzeigen',
  'permission_edit_communication_board_raw' : 'Communication Board Rohdaten bearbeiten',
  'permission_change_communication_board_status' : 'Communication Board Änderungen freigeben',
  'COMMUNICATION.Status_Pending' : 'Zur Freigabe',
  'COMMUNICATION.Status_Unidentified' : 'Zuordnung nötig',
  'COMMUNICATION.Status_Approved' : 'Freigegeben',
  'COMMUNICATION.Title_EmailChange' : 'E-Mail prüfen',
  'COMMUNICATION.Title_AuditEntry' : 'Verlaufseintrag',
  'COMMUNICATION.Title_DailySummary' : 'Aktuelle Übersicht nach Kunde',
  'COMMUNICATION.Title_OverallClientSummary' : 'Kunden mit Handlungsbedarf',
  'COMMUNICATION.Title_Filters' : 'Communication-Filter',
  'COMMUNICATION.Section_EmailMeta' : 'E-Mail-Metadaten',
  'COMMUNICATION.Section_Matching' : 'Zuordnung',
  'COMMUNICATION.Section_AIContext' : 'KI-Kontext',
  'COMMUNICATION.Section_AIContextSecondary' : 'Original-E-Mail anzeigen',
  'COMMUNICATION.Section_RequestGroups' : 'KI-geparste E-Mail-Positionen',
  'COMMUNICATION.Section_RequestGroupsHint' : 'Zeigt die urspruenglich aus der E-Mail erkannten Positionen inklusive Notizen und Confidence, nach Stand gruppiert und vor manuellen Aenderungen.',
  'COMMUNICATION.Section_FutureActions' : 'Zukünftige Aktionen',
  'COMMUNICATION.Section_FinalChanges' : 'Finale Änderungen',
  'COMMUNICATION.Section_Audit' : 'Audit-Trail',
  'COMMUNICATION.Preview_QuestionsOverview' : 'Offene Fragen',
  'COMMUNICATION.Preview_QuestionsWorking' : 'Kundenklaerungen',
  'COMMUNICATION.Preview_QuestionsWorkingHint' : 'Bearbeiten Sie diese Kundenklaerungen vor der finalen Freigabe. Sie koennen die bestaetigte Equipment-Auswahl veraendern.',
  'COMMUNICATION.Preview_QuestionsResult' : 'Klaerungsergebnis',
  'COMMUNICATION.Preview_QuestionsResultHint' : '{ reviewed } geprueft / { questions } Klaerungen gesamt vor der Freigabe.',
  'COMMUNICATION.Preview_Logistics' : 'Logistikübersicht',
  'COMMUNICATION.Preview_LogisticsExtracted' : 'Aus E-Mail extrahierte Positionen',
  'COMMUNICATION.Preview_LogisticsExtractedHint' : 'Zeigt die ursprünglich erkannten Positionen vor den manuellen Änderungen.',
  'COMMUNICATION.Preview_LogisticsFinal' : 'Finale Logistikübersicht',
  'COMMUNICATION.Preview_LogisticsFinalHint' : 'Basiert auf den aktuell bestätigten Änderungen.',
  'COMMUNICATION.Preview_OrderChangeAdd' : 'Änderung: { item }, insgesamt { qty } Stück{ color }',
  'COMMUNICATION.Preview_OrderChangeRemove' : 'Änderung: { item }, entfernen { qty } Stück{ color }',
  'COMMUNICATION.Preview_OrderChangeChange' : 'Änderung: { item }, anpassen { qty } Stück{ color }',
  'COMMUNICATION.Preview_OrderChangeFlooring' : 'Änderung: Teppichfarbe { color }',
  'COMMUNICATION.Preview_ItemFromEmail' : 'Position aus E-Mail',
  'COMMUNICATION.Preview_Product' : 'Equipment',
  'COMMUNICATION.Preview_TotalQty' : 'Gesamtmenge',
  'COMMUNICATION.Preview_EmailDate' : 'E-Mail Datum',
  'COMMUNICATION.Summary_Inbox' : 'Offene E-Mails',
  'COMMUNICATION.Summary_Pending' : 'Zur Freigabe',
  'COMMUNICATION.Summary_Unidentified' : 'Zuordnung nötig',
  'COMMUNICATION.Summary_Approved' : 'Heute freigegeben',
  'COMMUNICATION.Placeholder_Search' : 'Absender, Betreff, Messe, Firma, Stand suchen',
  'COMMUNICATION.Placeholder_FilterEvent' : 'z. B. AAA Heilbronn 2026',
  'COMMUNICATION.Placeholder_FilterSender' : 'z. B. anna@example.com oder Messeprojekt',
  'COMMUNICATION.Placeholder_FilterCompany' : 'z. B. BLOCK Transformatoren',
  'COMMUNICATION.Placeholder_FilterStand' : 'z. B. B-330',
  'COMMUNICATION.Placeholder_FilterDate' : 'TT.MM.JJJJ',
  'COMMUNICATION.ReadOnly_Label' : 'Bearbeitung erfordert Rechte',
  'COMMUNICATION.ReadOnly_Audit' : 'Audit ist schreibgeschützt',
  'COMMUNICATION.Reset_Title' : 'Communication-Board-Daten zurücksetzen?',
  'COMMUNICATION.Reset_Text' : 'Dadurch wird der lokale Demo-Status gelöscht und die Seed-Daten werden neu geladen.',
  'COMMUNICATION.Message_Saved' : 'Communication-Aufgabe gespeichert',
  'COMMUNICATION.Message_Approved' : 'Communication-Aufgabe freigegeben',
  'COMMUNICATION.TabTooltip_Inbox' : 'Alle offenen E-Mails, die noch bearbeitet werden müssen.',
  'COMMUNICATION.TabTooltip_Pending' : 'E-Mails mit erkannter Zuordnung, die nur noch geprüft und freigegeben werden müssen.',
  'COMMUNICATION.TabTooltip_Unidentified' : 'E-Mails ohne eindeutige Zuordnung zu Messe, Kunde oder Stand.',
  'COMMUNICATION.TabTooltip_Audit' : 'Vom Manager freigegebene Communication-Vorgänge.',
  'COMMUNICATION.Help_Inbox' : 'Alle offenen E-Mails, die noch bearbeitet werden müssen.',
  'COMMUNICATION.Help_Pending' : 'E-Mails mit erkannter Zuordnung, die nur noch geprüft und freigegeben werden müssen.',
  'COMMUNICATION.Help_Unidentified' : 'E-Mails ohne eindeutige Zuordnung zu Messe, Kunde oder Stand.',
  'COMMUNICATION.Help_Audit' : 'Vom Manager freigegebene Communication-Vorgänge.',
  'COMMUNICATION.Table_Email' : 'E-Mail',
  'COMMUNICATION.Table_EventCompany' : 'Messe / Kunde',
  'COMMUNICATION.Table_Stand' : 'Stand',
  'COMMUNICATION.Table_Changes' : 'Änderungen',
  'COMMUNICATION.Table_Questions' : 'Fragen',
  'COMMUNICATION.Table_NextStep' : 'Nächster Schritt',
  'COMMUNICATION.Table_Received' : 'Eingang',
  'COMMUNICATION.Table_Action' : 'Aktion',
  'COMMUNICATION.Results_Inbox' : '{ total } offene E-Mails insgesamt, { visible } in dieser Ansicht',
  'COMMUNICATION.Results_Audit' : '{ total } vom Manager freigegebene Vorgänge insgesamt, { visible } in dieser Ansicht',
  'COMMUNICATION.Hint_RowClickOpen' : 'Zeile anklicken, um den Review-Workflow zu öffnen',
  'COMMUNICATION.Hint_RowClickWorkflow' : 'Klicken, um den Review-Workflow zu öffnen',
  'COMMUNICATION.Filter_Event' : 'Messe',
  'COMMUNICATION.Text_NoQuestions' : 'Keine Fragen',
  'COMMUNICATION.Text_MultiStand' : 'Multi-stand',
  'COMMUNICATION.Text_ChangesCount' : '{ count } Änderungen',
  'COMMUNICATION.Text_ChangesMore' : '+{ count } mehr',
  'COMMUNICATION.Text_QuestionsCount' : '{ count } Fragen',
  'COMMUNICATION.Text_NoExtractedChanges' : 'Für diese E-Mail wurden keine erkannten Änderungen gefunden.',
  'COMMUNICATION.Text_NoFinalChanges' : 'Es gibt noch keine bestätigten Änderungen.',
  'COMMUNICATION.Text_QuestionsSummary' : '{ open } offen / { questions } gesamt',
  'COMMUNICATION.Info_OpenClarification' : '{ count } offene Klaerung',
  'COMMUNICATION.Info_OpenClarificationPlural' : '{ count } offene Klaerungen',
  'COMMUNICATION.Info_NeedsMatch' : 'Zuordnung noetig',
  'COMMUNICATION.TopClients_OpenQuestions' : '{ open } offene Fragen',
  'COMMUNICATION.TopClients_NeedMatch' : '{ count } Zuordnung nötig',
  'COMMUNICATION.TopClients_ToReview' : '{ count } zu prüfen',
  'COMMUNICATION.TopClients_EmailCount' : '{ total } E-Mail',
  'COMMUNICATION.TopClients_EmailCountPlural' : '{ total } E-Mails',
  'COMMUNICATION.TopClients_Unassigned' : 'Nicht zugeordnet',
  'COMMUNICATION.TopClients_EmptyAttention' : 'Keine Kunden mit offenem Handlungsbedarf',
  'COMMUNICATION.TopClients_MoreAttention' : '+ { count } weitere Kunden mit Handlungsbedarf',
  'COMMUNICATION.Info_ItemsCount' : '{ count } Position',
  'COMMUNICATION.Info_ItemsCountPlural' : '{ count } Positionen',
  'COMMUNICATION.Info_ChipQuestionsSingle' : '1 Frage',
  'COMMUNICATION.Info_ChipQuestions' : '{ count } Fragen',
  'COMMUNICATION.Info_StandGroupsCount' : '{ count } Stand',
  'COMMUNICATION.Info_StandGroupsCountPlural' : '{ count } Stände',
  'COMMUNICATION.NextStep_Match' : 'Zuordnung prüfen',
  'COMMUNICATION.NextStep_Review' : 'Aenderungen pruefen',
  'COMMUNICATION.NextStep_History' : 'Verlauf ansehen',
  'COMMUNICATION.Button_View' : 'Ansehen',
  'COMMUNICATION.Button_Open' : 'Oeffnen',
  'COMMUNICATION.Button_StartMatch' : 'Zuordnung pruefen',
  'COMMUNICATION.Button_StartReview' : 'Aenderungen pruefen',
  'COMMUNICATION.Button_Back' : 'Zurück',
  'COMMUNICATION.Button_Next' : 'Weiter',
  'COMMUNICATION.Button_SaveAndClose' : 'Speichern und schließen',
  'COMMUNICATION.Button_ChooseAnother' : 'Ändern',
  'COMMUNICATION.Button_AddChange' : 'Änderung hinzufügen',
  'COMMUNICATION.Button_AddStandUpdate' : 'Standanpassung hinzufügen',
  'COMMUNICATION.Button_AddManagerNote' : 'Manager-Notiz hinzufügen',
  'COMMUNICATION.Action_StandUpdate' : 'Standanpassung',
  'COMMUNICATION.Action_ManagerNote' : 'Manager-Notiz',
  'COMMUNICATION.Button_AddQuestion' : 'Frage hinzufügen',
  'COMMUNICATION.Button_CollapseEmail' : 'E-Mail einklappen',
  'COMMUNICATION.Button_ExpandEmail' : 'E-Mail aufklappen',
  'COMMUNICATION.Button_ShowAllChanges' : 'Alle { count } Г„nderungen anzeigen',
  'COMMUNICATION.Button_CollapseChanges' : 'Г„nderungen einklappen',
  'COMMUNICATION.Warning_UnsavedChangesConfirm' : 'Sie haben ungespeicherte Änderungen in dieser Prüfung. Verwerfen und fortfahren?',
  'COMMUNICATION.EquipmentSuggestion_Badge' : 'KI Vorschlag',
  'COMMUNICATION.EquipmentSuggestion_ConfirmedBadge' : 'Bestätigt',
  'COMMUNICATION.EquipmentSuggestion_ChangedBadge' : 'Geändert',
  'COMMUNICATION.EquipmentSuggestion_Pending' : 'Vorschlag bestätigen oder ändern.',
  'COMMUNICATION.EquipmentSuggestion_Confirmed' : 'Vorschlag bestätigt.',
  'COMMUNICATION.EquipmentSuggestion_Changed' : 'Anderes Equipment ausgewählt.',
  'COMMUNICATION.EquipmentSuggestion_PendingSummary' : '{ count } KI Vorschläge müssen noch bestätigt werden.',
  'COMMUNICATION.QuestionStatus_Open' : 'Offen',
  'COMMUNICATION.QuestionStatus_Reviewed' : 'Geprüft',
  'COMMUNICATION.Field_Question' : 'Frage',
  'COMMUNICATION.Field_Clarification' : 'Klaerung',
  'COMMUNICATION.Field_QuestionStatus' : 'Fragenstatus',
  'COMMUNICATION.Validation_Question' : 'Bitte eine Frage eingeben',
  'COMMUNICATION.Validation_SelectEquipmentOrDelete' : 'Bitte Equipment aus dem Katalog auswählen oder diese Zeile löschen.',
  'COMMUNICATION.Match_NotReady' : 'Diese E-Mail bleibt in „Zuordnung nötig“, bis Messe, Firma und Stand ausgefüllt sind.',
  'COMMUNICATION.Warning_MatchRequired' : 'Eine Freigabe ist erst möglich, wenn Messe, Firma und Stand bestätigt sind.',
  'COMMUNICATION.Warning_OpenQuestions' : 'Für diese E-Mail gibt es noch offene Fragen.',
  'COMMUNICATION.Warning_OpenQuestionsNonBlocking' : 'Offene Fragen dürfen bestehen bleiben. Sie blockieren die Freigabe nicht.',
  'COMMUNICATION.Warning_OpenQuestionsCompact' : 'Offene Fragen blockieren die Freigabe nicht.',
  'COMMUNICATION.Step_Matching_Title' : '1. Zuordnung prüfen',
  'COMMUNICATION.Step_Matching_Help' : 'Bestätigen Sie zuerst Messe, Firma und Stand, bevor die E-Mail in „Zur Freigabe“ wechselt.',
  'COMMUNICATION.Step_Changes_Title' : '2. Änderungen und Klärungen prüfen',
  'COMMUNICATION.Step_Changes_Help' : 'Prüfen Sie die erkannten Equipment-Änderungen und Kundenklärungen und korrigieren Sie sie bei Bedarf.',
  'COMMUNICATION.Step_Questions_Title' : '3. Finale Prüfung',
  'COMMUNICATION.Step_Questions_Help' : 'Prüfen Sie das finale Logistik-Ergebnis und den Fragenstatus vor der Freigabe.',
  'COMMUNICATION.StepStatus_Ready' : 'Bereit',
  'COMMUNICATION.StepStatus_NeedsMatch' : 'Zuordnung fehlt',
  'COMMUNICATION.StepStatus_CompleteStep1First' : 'Zuerst Schritt 1 abschliessen',
  'COMMUNICATION.StepStatus_CompleteStep2First' : 'Zuerst Schritt 2 abschliessen',
  'COMMUNICATION.StepStatus_ReviewCount' : '{ count } prüfen',
  'COMMUNICATION.StepStatus_PendingCount' : '{ count } ausstehend',
  'COMMUNICATION.StepStatus_NoPending' : 'Nichts ausstehend',
  'COMMUNICATION.StepStatus_NoExtractedChanges' : 'Keine extrahierten Aenderungen',
  'COMMUNICATION.StepStatus_OpenCount' : '{ count } offen',
  'COMMUNICATION.StepStatus_NoQuestions' : 'Keine Fragen',
  'COMMUNICATION.StepStatus_FinalCheck' : 'Final pruefen',
  'COMMUNICATION.StepStatus_ReadyToApprove' : 'Freigabebereit',
  'COMMUNICATION.StepAction_ContinueMatching' : 'Bitte zuerst Messe, Firma und Stand vervollständigen, um weiterzugehen.',
  'COMMUNICATION.StepAction_ApproveMatching' : 'Bitte zuerst Messe, Firma und Stand vervollständigen, bevor freigegeben wird.',
  'COMMUNICATION.Step_Confirm_Title' : '4. Freigeben',
  'COMMUNICATION.Step_Confirm_Help' : 'Geben Sie das bereinigte Ergebnis frei, sobald Zuordnung und Änderungen korrekt sind.',
  'COMMUNICATION.Empty_Inbox' : 'Keine offenen E-Mails',
  'COMMUNICATION.Empty_Pending' : 'Keine E-Mails zur Freigabe',
  'COMMUNICATION.Empty_Unidentified' : 'Keine E-Mails mit offener Zuordnung',
  'COMMUNICATION.Empty_Audit' : 'Keine vom Manager freigegebenen Vorgänge',
  'COMMUNICATION.Action_Add' : 'Hinzufügen',
  'COMMUNICATION.Action_Remove' : 'Entfernen',
  'COMMUNICATION.Action_Change' : 'Ändern',
  'COMMUNICATION.PreviewMode_Message' : 'Nur Vorschau: Änderungen bleiben lokal in diesem Drawer.',
  'COMMUNICATION.PreviewMode_ResetNote' : 'Änderungen werden noch nicht gespeichert und beim Schließen des Drawers zurückgesetzt. Speichern und Freigabe kommen in der nächsten Phase.',
  'COMMUNICATION.PreviewMode_PageNote' : 'Präsentationsmodus: Board-Aktionen bleiben interaktiv, Änderungen im Drawer sind vorerst nur Vorschau.',
  'COMMUNICATION.Demo_MultiStandBadge' : 'Demo Multi-Stand',
  'COMMUNICATION.Demo_MultiStandNote' : 'Demonstrations-E-Mail zur Validierung des Multi-Stand-UI. Reale Backend-E-Mails mit mehreren Standen liegen noch nicht vor, daher bleibt dieses Beispiel bewusst im Board.',
  'TEAM_ROLES.project_manager' : 'Projektmanager',
  'COMMUNICATION.Summary_ParserProcessed' : 'Heute vom Parser verarbeitet',
  'COMMUNICATION.Summary_ManagerApproved' : 'Heute vom Manager freigegeben',
  'COMMUNICATION.Validation_SelectEquipmentForItemOrDelete' : '"{ item }" aus dem Katalog zuordnen oder diese Zeile loeschen.',
  'COMMUNICATION.StepStatus_Reviewed' : 'Geprueft',
  'COMMUNICATION.StepHint_RequiredFields' : 'Pflichtfelder: { fields }',
  'COMMUNICATION.StepHint_AIPendingCount' : '{ count } KI offen',
  'COMMUNICATION.StepHint_CatalogMatchCount' : '{ count } Katalogzuordnung fehlt',
  'COMMUNICATION.StepHint_OpenQuestionsCount' : '{ count } offene Fragen',
  'COMMUNICATION.StepHint_ChangesDone' : 'Alle Positionen geprueft',
  'COMMUNICATION.StepHint_NoExtractedChanges' : 'Fuer diese E-Mail wurden keine extrahierten Aenderungen gefunden.',
  'COMMUNICATION.StepHint_NoPendingChanges' : 'Keine offenen Aenderungen. Sie koennen fortfahren.',
  'COMMUNICATION.Field_StandNumbers' : 'Standnummern',
  'COMMUNICATION.Hint_MultiStandMatching' : 'Diese E-Mail enthaelt mehrere erkannte Stand-Gruppen. Bestaetigen Sie hier jeden Stand, bevor Sie fortfahren.',
  'COMMUNICATION.Button_AddStandNumber' : 'Stand hinzufuegen',
  'COMMUNICATION.Confidence_High' : 'Hohe Sicherheit',
  'COMMUNICATION.Confidence_Medium' : 'Bitte pruefen',
  'COMMUNICATION.Confidence_Low' : 'Niedrige Sicherheit',
  'COMMUNICATION.Button_OpenInMyStand' : 'Stand in myStand öffnen',
  'COMMUNICATION.Button_ReplyToCustomer' : 'Dem Kunden antworten',
  'COMMUNICATION.WorkState_Label' : 'Bearbeitungsstatus',
  'COMMUNICATION.WorkState_Untouched' : 'Unberührt',
  'COMMUNICATION.WorkState_InProgress' : 'In Bearbeitung',
  'COMMUNICATION.WorkState_Approved' : 'Bestätigt',
  'COMMUNICATION.WorkState_LastTouched' : 'Zuletzt bearbeitet { date }',
  'COMMUNICATION.WorkState_Placeholder' : 'Lokale Konzeptvorschau, bis ein persistenter Backend-Status für Zuständigkeit verfügbar ist.',
  'COMMUNICATION.RequestStatus_Pending' : 'Offen',
  'COMMUNICATION.RequestStatus_Unidentified' : 'Nicht zugeordnet',
  'COMMUNICATION.RequestStatus_Approved' : 'Bestätigt',
  'COMMUNICATION.RequestStatus_Rejected' : 'Abgelehnt',
  'COMMUNICATION.RequestStatus_Cancelled' : 'Storniert',
  'COMMUNICATION.RequestGroup_ByStand' : 'Nach Stand gruppiert',
  'COMMUNICATION.RequestGroup_StandFallback' : 'Stand noch nicht zugeordnet',
  'COMMUNICATION.RequestGroup_EventFallback' : 'Veranstaltung nicht zugeordnet',
  'COMMUNICATION.RequestGroup_CompanyFallback' : 'Firma nicht zugeordnet',
  'COMMUNICATION.RequestGroup_GroupSingle' : '{ count } Stand-Gruppe',
  'COMMUNICATION.RequestGroup_Groups' : '{ count } Stand-Gruppen',
  'COMMUNICATION.RequestGroup_ParsedItemSingle' : '{ count } geparste Position',
  'COMMUNICATION.RequestGroup_ParsedItems' : '{ count } geparste Positionen',
  'COMMUNICATION.RequestGroup_ItemSingle' : '{ count } Position',
  'COMMUNICATION.RequestGroup_Items' : '{ count } Positionen',
  'COMMUNICATION.RequestGroup_QuestionSingle' : '{ count } Frage',
  'COMMUNICATION.RequestGroup_Questions' : '{ count } Fragen',
  'COMMUNICATION.RequestGroup_UnidentifiedSingle' : '{ count } nicht zugeordnet',
  'COMMUNICATION.RequestGroup_Unidentified' : '{ count } nicht zugeordnet',
  'COMMUNICATION.RequestGroup_SectionReview' : 'Geparste Aenderungen',
  'COMMUNICATION.RequestGroup_SectionReviewHint' : 'Diese geparsten Bestellpositionen laufen weiter durch Pruefung und Freigabe.',
  'COMMUNICATION.RequestGroup_SectionUnidentified' : 'Manuelle Zuordnung noetig',
  'COMMUNICATION.RequestGroup_SectionUnidentifiedHint' : 'Diese Positionen muessen vor der Bestaetigung manuell geklaert werden.',
  'COMMUNICATION.RequestGroup_SectionQuestions' : 'Fragen aus der E-Mail',
  'COMMUNICATION.RequestGroup_SectionQuestionsHint' : 'Diese Fragen bleiben während der Prüfung sichtbar, weil sie die finalen Änderungen beeinflussen können.',
  'COMMUNICATION.RequestGroup_Confidence' : '{ count }% Sicherheit',
  'COMMUNICATION.RequestGroup_ItemNotes' : 'Notiz: { note }',
  'COMMUNICATION.Concept_OriginalEmailHint' : 'Die Original-E-Mail bleibt als primärer Kontext für die Prüfung durch den Manager sichtbar.',
  'COMMUNICATION.Concept_MultiGroupHint' : 'Diese E-Mail enthält bereits mehrere geparste Stand-Gruppen. Das aktuelle Konzept behält die Parent-E-Mail bei und zeigt die Child-Gruppen darunter an.',
  'COMMUNICATION.Concept_WorkStateNote' : 'Persistente Zuständigkeit, Sperren und Last-Touch-Metadaten benötigen Backend-Unterstützung und werden hier nur als Konzeptstatus angezeigt.',
  'COMMUNICATION.Concept_FutureActionsTitle' : 'Projektkontext und Antwortaktionen',
  'COMMUNICATION.Concept_OpenInMyStandTitle' : 'Projektkontext öffnen',
  'COMMUNICATION.Concept_OpenInMyStandNote' : 'Die echte Aktion öffnet den richtigen Stand oder das richtige Projekt in myStand, sobald der Backend-Route-Contract verfügbar ist.',
  'COMMUNICATION.Concept_ReplyTitle' : 'Antwort-Workflow',
  'COMMUNICATION.Concept_ReplyNote' : 'Antwort, Thread-Kontext und Versand sind Konzept-Platzhalter, bis die Backend-E-Mail-Aktionen angebunden sind.',
  'COMMUNICATION.Concept_FutureActionsHint' : 'Diese Aktionen zeigen bereits die spätere Workflow-Form. Sie bleiben deaktiviert, bis die API-Unterstützung vorhanden ist.',
  'COMMUNICATION.QuestionsWorkflow_Label' : 'Kommunikations-Follow-up',
  'COMMUNICATION.QuestionsWorkflow_Title' : 'Kundenklaerung',
  'COMMUNICATION.QuestionsWorkflow_Hint' : 'Nutzen Sie Projektkontext und Kundenantwort, wenn vor der weiteren Pruefung Rueckfragen zur E-Mail noetig sind.',
  'COMMUNICATION.QuestionsWorkflow_RelatedStand' : 'Zugehoeriger Stand { stand }',
  'COMMUNICATION.QuestionsWorkflow_ClarificationNeeded' : 'Rueckfrage noetig',
  'COMMUNICATION.QuestionsWorkflow_AffectsChanges' : 'Kann Aenderungen beeinflussen',
  'COMMUNICATION.QuestionsWorkflow_ApiPending' : 'API ausstehend',
  'COMMUNICATION.QuestionsWorkflow_Note' : 'Aktionen werden nach der Backend-Integration verfuegbar.',
  'COMMUNICATION.Step2Summary_ChangesLabel' : 'Aenderungen pruefen',
  'COMMUNICATION.Step2Summary_ClarificationsLabel' : 'Klaerungen',
  'COMMUNICATION.Step2Summary_StandsLabel' : 'Stand-Gruppen',
  'COMMUNICATION.Step1Summary_StandsLabel' : 'Erkannte Staende',
  'COMMUNICATION.Step1Summary_ParserConfidenceLabel' : 'Parser-Sicherheit',
  'COMMUNICATION.Step1Summary_UnresolvedLabel' : 'Offene Punkte',
  'COMMUNICATION.Step1Summary_UnresolvedHint' : '{ count } Positionen manuell pruefen',
  'COMMUNICATION.Step1Summary_UnresolvedClear' : 'Keine offenen Parser-Punkte',
  'COMMUNICATION.Step1Summary_ClarificationsLabel' : 'Klaerungen',
  'COMMUNICATION.QuestionCard_Label' : 'Kundenklaerung',
  'COMMUNICATION.QuestionCard_Hint' : 'Klaeren Sie diese Rueckfrage vor der finalen Freigabe, wenn sie das Equipment beeinflusst.',
  'COMMUNICATION.QuestionCard_ImpactHint' : 'Vor der finalen Freigabe klaeren, wenn es das Equipment beeinflussen kann.',
  'COMMUNICATION.QuestionCard_AffectsChanges' : 'Beeinflusst Aenderungen',
  'COMMUNICATION.QuestionCard_FollowUp' : 'Kunden-Follow-up',
  'COMMUNICATION.QuestionCard_RelatedStand' : 'Zugehoeriger Stand { stand }',
  'COMMUNICATION.QuestionCard_RelatedStands' : '{ count } zugehoerige Staende',
  'COMMUNICATION.QuestionCard_WhyLabel' : 'Warum es wichtig ist',
  'COMMUNICATION.QuestionCard_RequestLabel' : 'Kundennachricht',
  'COMMUNICATION.QuestionCard_StatusLabel' : 'Klaerungsstatus',
  'COMMUNICATION.HandoffNote_Title' : 'Kundenantwort-Entwurf',
  'COMMUNICATION.HandoffNote_Hint' : 'Bereiten Sie hier die kundenbezogene Antwort vor. Schnellantworten koennen den Entwurf vorbefuellen, bevor er in der Mail-App geoeffnet wird.',
  'COMMUNICATION.HandoffNote_Placeholder' : 'Antwort an den Kunden hier entwerfen. Dieser Text wird in der Mail-App als Entwurf geoeffnet.',
  'COMMUNICATION.HandoffNote_Add' : 'Kundenantwort-Entwurf hinzufuegen',
  'COMMUNICATION.HandoffNote_StatusPrepared' : 'Entwurf bereit',
  'COMMUNICATION.HandoffNote_StatusEmpty' : 'Noch kein Entwurf',
  'COMMUNICATION.HandoffNote_SummaryTitle' : 'Zusammenfassung des Kundenantwort-Entwurfs',
  'COMMUNICATION.HandoffNote_SummaryHint' : 'Dieser Entwurf bleibt hier read-only sichtbar, damit das spaetere Kunden-Follow-up klar uebergeben werden kann.',
  'COMMUNICATION.HandoffNote_EmptyPreview' : 'Es wurde kein Kundenantwort-Entwurf vorbereitet.',
  'COMMUNICATION.FinalFollowUp_Title' : 'Kunden-Follow-up-Zusammenfassung',
  'COMMUNICATION.FinalFollowUp_Hint' : 'Zeigt den vorbereiteten Antwortentwurf und ob nach der Freigabe noch ein Kunden-Follow-up noetig ist.',
  'COMMUNICATION.ReplyDraft_QuickReplies' : 'Schnellantworten',
  'COMMUNICATION.ReplyDraft_To' : 'An',
  'COMMUNICATION.ReplyDraft_Subject' : 'Betreff',
  'COMMUNICATION.ReplyDraft_OpenMailApp' : 'Entwurf in Mail-App oeffnen',
  'COMMUNICATION.ReplyDraft_OpenMailAppHint' : 'Oeffnet Ihre Standard-Mail-App mit dem aktuellen Antwortentwurf.',
  'COMMUNICATION.ReplyDraft_TemplateAvailable' : 'Ja, verfuegbar',
  'COMMUNICATION.ReplyDraft_TemplateUnavailable' : 'Nicht verfuegbar',
  'COMMUNICATION.ReplyDraft_TemplateUnderReview' : 'Wird geprueft',
  'COMMUNICATION.ReplyDraft_TextAvailable' : 'Hallo,\n\nwir haben Ihre Anfrage geprueft und bestaetigen, dass dies verfuegbar ist.\n\nViele Gruesse',
  'COMMUNICATION.ReplyDraft_TextUnavailable' : 'Hallo,\n\nwir haben Ihre Anfrage geprueft und bestaetigen, dass dies derzeit nicht verfuegbar ist.\n\nViele Gruesse',
  'COMMUNICATION.ReplyDraft_TextUnderReview' : 'Hallo,\n\nwir pruefen Ihre Anfrage und melden uns in Kuerze zurueck.\n\nViele Gruesse',
  'COMMUNICATION.ReplyDraft_RecipientMissing' : 'Keine Absender-E-Mail vorhanden',
  'COMMUNICATION.NextAction_Title' : 'Naechste Aktion nach Freigabe',
  'COMMUNICATION.NextAction_Hint' : 'Zeigt, ob der Vorgang mit der Freigabe endet oder ob noch ein Kunden-Follow-up erwartet wird.',
  'COMMUNICATION.NextAction_NoFollowUpNeeded' : 'Kein Follow-up noetig',
  'COMMUNICATION.NextAction_FollowUpNeeded' : 'Kunden-Follow-up noetig',
  'COMMUNICATION.Action_Question' : 'Frage',
  'COMMUNICATION.Relative_JustNow' : 'gerade eben',
  'COMMUNICATION.Relative_MinutesAgo' : 'vor { count } Min.',
  'COMMUNICATION.Relative_HoursAgo' : 'vor { count } Std.',
  'COMMUNICATION.Relative_Today' : 'heute',
  'COMMUNICATION.Relative_Yesterday' : 'gestern',
  'COMMUNICATION.PageTitle' : 'Communication Board',
  'TEAM_ROLES.construction_manager' : 'Bauleiter',
  'TEAM_ROLES.draftsmen' : 'CAD-Zeichner',
};

export default deutsch;

